<template>
  <a-spin :spinning="confirmLoading">
    <detail-list :col="2">
      <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
      <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
      <detail-list-item :term="$t('新用户姓名')">{{model.userName}}</detail-list-item>
      <detail-list-item :term="$t('旧用户姓名')">{{model.oldUserName}}</detail-list-item>
      <detail-list-item :term="$t('原用户手机号')">{{model.oldUserPhone}}</detail-list-item>
      <detail-list-item :term="$t('新用户手机号')">{{model.userPhone}}</detail-list-item>
      <detail-list-item :term="$t('新身份证号')">{{model.userIdNumber}}</detail-list-item>
      <detail-list-item :term="$t('原身份证号')">{{model.oldUserIdNumber}}</detail-list-item>
      <detail-list-item :term="$t('新用户类型名称')">{{model.utName}}</detail-list-item>
      <detail-list-item :term="$t('原用户类型名称')">{{model.oldUtName}}</detail-list-item>
      <detail-list-item :term="$t('新价格名称')">{{model.wtName}}</detail-list-item>
      <detail-list-item :term="$t('原价格名称')">{{model.oldWtName}}</detail-list-item>
      <detail-list-item :term="$t('新身份类型')">{{model.userIdType==0?$t('企业'):model.userIdType==1?$t('自然人'):''}}</detail-list-item>
      <detail-list-item :term="$t('原身份类型')">{{model.oldUserIdType==0?$t('企业'):model.oldUserIdType==1?$t('自然人'):''}}</detail-list-item>
      <detail-list-item :term="$t('新优惠信息')">{{'user_free_type'|filterDictTextByCache(model.userFreeinfo)}}</detail-list-item>
      <detail-list-item :term="$t('原优惠信息')">{{'user_free_type'|filterDictTextByCache(model.oldUserFreeinfo)}}</detail-list-item>
      <detail-list-item :term="$t('过户原因')" :itemCol="1">{{model.transferReason}}</detail-list-item> 
    </detail-list>
  </a-spin>
</template>

<script>
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item

  export default {
    name: 'MeterUserinfoTransferRecordForm',
    components: {
      DetailList,
      DetailListItem
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    filters: {
      filterDictTextByCache
    },
    data () {
      return {
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
        }
      }
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>